import React, { useEffect, useState } from 'react';
import { Container, Grid, Box, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { getFavorites } from '../../actions/profile';
import { getCategories } from '../../actions/categories';
import FavoritesHeader from '../../components/user/favorites/FavoritesHeader';
import FavoritesSidebar from '../../components/user/favorites/FavoritesSidebar';
import FavoritesList from '../../components/user/favorites/FavoritesList';

const Favorites = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { favorites, loading } = useSelector(state => state.profile);
  const { categories } = useSelector(state => state.cat);
  const authUser = useSelector(state => state.user.user);

  const [filters, setFilters] = useState({
    category: '',
    sort: 'recent',
    showServices: true,
    showPages: true
  });

  useEffect(() => {
    // Solo la persona dueña ve sus favoritos. Al abrir la dirección o al recargar, la sesión llega después (empieza vacía):
    // hasta saber quién es no se decide nada
    if (!authUser?._id) return;
    if (authUser._id !== id) {
      navigate('/');
      return;
    }
    dispatch(getFavorites());
    dispatch(getCategories());
  }, [id, authUser, dispatch, navigate]);

  if (loading && favorites.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const filteredFavorites = favorites.filter(srv => {
    // Filter by Category
    if (filters.category && srv.categoria !== filters.category) return false;

    // Filter by Type (Services vs Pages)
    if (!filters.showServices && !srv.isPage) return false;
    if (!filters.showPages && srv.isPage) return false;

    return true;
  }).sort((a, b) => {
    if (filters.sort === 'rating') {
      return (b.rating || 0) - (a.rating || 0);
    }
    return 0; // Default: returned order from backend
  });

  return (
    <Container maxWidth="xl" sx={{ mt: 15, mb: 8 }}>
      <FavoritesHeader />
      <Grid container spacing={4}>
        {favorites.length > 0 ? (
          <>
            <Grid size={{ xs: 12, md: 3 }}>
              <FavoritesSidebar
                categories={categories}
                filters={filters}
                setFilters={setFilters}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 9 }}>
              <FavoritesList favorites={filteredFavorites} total={favorites.length} />
            </Grid>
          </>
        ) : (
          <Grid size={12}>
            <FavoritesList favorites={[]} />
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default Favorites;
